import { Link } from "react-router-dom";
import { vehicleImage } from "../data/content";
import { useSiteContent } from "../siteContent";

export default function About() {
  const { company, copy, habits, people, stateCount } = useSiteContent();
  const glance = [
    { label: "Headquarters", value: company.glanceHeadquarters },
    { label: "Firm type", value: company.glanceFirmType },
    { label: "States served", value: String(stateCount) },
    { label: "Coach fleet", value: company.glanceCoachFleet },
    { label: "In service since", value: company.glanceSince },
  ];
  return (
    <>
      <section className="bg-[#0B6A34] text-white">
        <div className="container-page py-14 sm:py-16">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#b7e7a8]">About us</p>
          <h1 className="mt-3 max-w-3xl text-3xl font-bold leading-tight sm:text-5xl">
            {company.aboutHeadline}
          </h1>
        </div>
      </section>

      <section className="bg-white py-14 sm:py-16">
        <div className="container-page grid items-center gap-8 lg:grid-cols-2">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#0B6A34]">{company.aboutKicker}</p>
            <h2 className="mt-2 text-3xl font-bold text-[#16301f]">{company.aboutTitle}</h2>
            <p className="mt-4 text-base leading-relaxed text-slate-600">{company.aboutBody}</p>
            <p className="mt-3 text-sm leading-relaxed text-slate-500">{company.aboutNote}</p>
          </div>
          <img src={vehicleImage} alt="Essaar coaches" className="h-full max-h-[420px] w-full rounded-xl object-cover" />
        </div>
      </section>

      <section className="bg-[#f4f7f5] py-14">
        <div className="container-page">
          <h2 className="text-2xl font-bold text-[#16301f]">Essaar at a glance</h2>
          <dl className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
            {glance.map((item) => (
              <div key={item.label} className="rounded-xl border border-[#d5e4d9] bg-white p-4">
                <dt className="text-xs font-semibold uppercase tracking-wide text-[#5d6b62]">{item.label}</dt>
                <dd className="mt-2 text-lg font-bold text-[#16301f]">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </section>

      <section className="bg-white py-14 sm:py-16">
        <div className="container-page">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#0B6A34]">{copy.habits_kicker}</p>
          <h2 className="mt-2 max-w-xl text-3xl font-bold text-[#16301f]">{copy.habits_title}</h2>
          <div className="mt-8 grid gap-6 lg:grid-cols-3">
            {habits.map((habit) => (
              <article key={habit.title}>
                <h3 className="font-bold text-[#16301f]">{habit.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{habit.description}</p>
              </article>
            ))}
          </div>
          <img
            src={vehicleImage}
            alt="Essaar cargo movement"
            className="mt-10 h-64 w-full rounded-xl object-cover sm:h-80"
          />
        </div>
      </section>

      <section className="bg-[#f4f7f5] py-14 sm:py-16">
        <div className="container-page">
          <h2 className="text-2xl font-bold text-[#16301f]">{copy.people_title}</h2>
          <div className="mt-8 grid gap-6 sm:grid-cols-3">
            {people.map((person, index) => (
              <article key={`${person.role}-${index}`} className="text-center">
                <img src={vehicleImage} alt="" className="aspect-square w-full rounded-xl object-cover" />
                <h3 className="mt-3 font-bold text-[#16301f]">{person.name}</h3>
                <p className="text-sm text-slate-500">{person.role}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#0B6A34] py-12 text-white">
        <div className="container-page flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <div>
            <h2 className="text-2xl font-bold">Ready to send something?</h2>
            <p className="mt-2 text-sm text-white/80">Tell us the route and the goods and a branch will call you back.</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/service-enquiry" className="rounded-md bg-[#6fbf45] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#5eaa38]">
              Send a service enquiry
            </Link>
            <Link to="/contact-us" className="rounded-md border border-white px-4 py-2.5 text-sm font-semibold text-white hover:bg-white/10">
              Contact us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
